import PendingPaymentDialog from "components/Payments/PendingPaymentDialog";
import {
  editPendingModulePayment,
  withdrawModulePayment,
} from "views/admin/Accounts/verification/modulePaymentVerificationApi";

const toModulePayload = ({ attachments, ...values }) => ({
  ...values,
  receiptDocuments: attachments,
});

/**
 * Edit or withdraw a pending module payment (Visa, Insurance, RPL, Skill Assessment, Other).
 * onResubmit receives the module resubmit payload shape ({ ..., receiptDocuments }).
 */
const PendingModulePaymentDialog = ({ onResubmit, ...props }) => (
  <PendingPaymentDialog
    {...props}
    showMethod
    saveEdit={(payment, values) =>
      editPendingModulePayment(payment.id, {
        expectedRevision: payment.revision,
        ...toModulePayload(values),
      })
    }
    withdraw={(payment, reason) =>
      withdrawModulePayment(payment.id, { expectedRevision: payment.revision, reason })
    }
    onResubmit={
      onResubmit ? (payment, values) => onResubmit(payment, toModulePayload(values)) : undefined
    }
  />
);

export default PendingModulePaymentDialog;
